<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="48px"
        viewBox="0 0 24 24"
        width="48px"
        :class="{
            'fill-gender-male': gender('MALE'),
            'fill-gender-female': gender('FEMALE'),
            'fill-base-content': other(),
        }"
        class="md:mr-2"
    >
        <path d="M0 0h24v24H0z" fill="none" />
        <path
            d="M 12,4 C 9.79,4 8,5.79 8,8 c 0,2.21 1.79,4 4,4 2.21,0 4,-1.79 4,-4 0,-2.21 -1.79,-4 -4,-4 z m 0,9 c -2.67,0 -8,1.34 -8,4 v 3 h 16 v -3 c 0,-2.66 -5.33,-4 -8,-4 z"
        />
    </svg>
</template>

<script>
export default {
    name: 'AccountFullIcon',
    props: {
        sex: {
            type: String,
        },
    },
    methods: {
        gender(sex) {
            return this.sex === sex;
        },
        other() {
            return this.sex !== 'MALE' && this.sex !== 'FEMALE';
        },
    },
};
</script>

<style scoped></style>
